import { getSelectedItemsTitle } from './common';
import { jobsSDRQuotaTypes } from '@/components/partials/jobs/constants/selectableOptions';
import type { InquiryForm } from '~/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export const getSdrQuotaTypeFieldValue = (inquiry: InquiryForm) => {
  if (!inquiry?.sdrQuotaTypes) return undefined;

  const quotaTypes = getSelectedItemsTitle(inquiry.sdrQuotaTypes, jobsSDRQuotaTypes);

  if (!quotaTypes.length) return '';

  return quotaTypes.join(', ');
};
